


import React from "react";
import bgimage from "../../app/assets/img/aadi.gif";
import { useHistory } from "react-router-dom";
import logo from "../../app/assets/img/pg-logo4.png";

const DefaultPage = ({ newChatStart }) => {
  const history = useHistory();

  return (
    <div className="mx-auto p-8 pt-4">
      <div className="flex flex-col gap 2">
        <div>
          <div style={{alignContent:"center",alignItems:"center"}} className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#1d64ac] to-[#1d64ac] mb-4  flex gap-1 text-center align-center">
           <span> Welcome to</span> 
           <div className="mt-1"><img width={65} src={logo} alt="Aadi" /></div>
           <div className="text-[#bb1ccc]">- AADI</div>
          </div>

          <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Co-Pilot for SD Planning & Trade Fund Excellence.
          </h2>

          <p className="text-gray-600 mb-2 leading-relaxed max-w-8xl text-[14px]">
          Reinvent how CPG enterprises manage demand, distributors, and trade investments.
          Harness a unified intelligence layer that connects planning, forecasting, price–pack strategy, promotion effectiveness, fund allocation, claims validation, and market execution.
          Powered by adaptive agents, graph intelligence, and natural language interaction, the Co-Pilot creates a collaborative decision fabric across commercial and operations teams—accelerating growth through precision planning and optimized trade spend.
          </p>

          <div className="max-w-4xl">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Why Aadi?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li className="text-[12px]">
                 <span className="text-[12px]">Custom Date Ranges</span > –
                Generate focused, in-depth supply chain summaries tailored to your operational goals.
              </li>
              <li className="text-[12px]">
                 <span className="text-[12px]">Instant Insights</span> –
                Access real-time intelligence across suppliers, logistics, and inventory performance without manual effort.
              </li>
              <li className="text-[12px]">
                 <span className="text-[12px]">Market Coverage</span> – Stay updated on supplier reliability, shipment trends, geopolitical risks, and regulatory changes impacting your supply chain.
              </li>
             
            </ul>
          </div>
        </div>

        <div style={{ minHeight: "20px" }}></div>

        <div
          style={{
            backgroundImage: `url(${bgimage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="bg-black rounded-2xl p-8 relative overflow-hidden h-[300px]"
        >
          <div style={{alignContent:"center",alignItems:"center"}} className="relative z-10 grid gap-4 h-[100%]">
            <h3 className="text-2xl font-bold bg-clip-text bg-gradient-to-r text-[#ffffff]">
              Ask Aadi
            </h3>
            <p className="text-white max-w-[60%]">
            The intelligence layer for SD Planning & Trade Fund strategy—uncovering growth opportunities, evaluating promotion effectiveness, and guiding data-driven decisions in dynamic markets.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={newChatStart}
                className="flex items-center space-x-2 px-6 py-2 border border-gray-600 rounded-lg text-white hover:bg-white/10 transition-colors bg-transparent"
              >
                <div className="w-4 h-4 border border-current rounded-full flex items-center justify-center">
                  <div className="w-2 h-2 bg-current rounded-full"></div>
                </div>
                <span>Start Chat</span>
              </button>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultPage;

